/** 与 java_save {@code DistributionHttpHeaders} 同名同值 */
export const DistributionHttpHeaders = {
  PARTNER_REF: 'partnerRef',
  REF: 'ref',
  PROMOTION_LINK: 'promotionLink',
  /** PC/H5 分享渠道，与 URL 参数名一致 */
  SHARE_CHANNEL: 'shareChannel'
} as const

/** 与 java_save / 产品文档一致的键名与 30 天策略 */
export const JUFAIR_PARTNER_REF_KEY = 'jufair_partner_ref'
/** 与 ref 同周期持久化，供请求头与访客上报透传 */
export const JUFAIR_SHARE_CHANNEL_KEY = 'jufair_share_channel'
export const JUFAIR_VISITOR_ID_KEY = 'jufair_visitor_id'
const PARTNER_REF_MAX_LEN = 64
const SHARE_CHANNEL_MAX_LEN = 80

export function normalizePartnerRef(value: unknown): string | null {
  if (value == null) return null
  const s = String(value).trim()
  if (!s || s.length > PARTNER_REF_MAX_LEN) return null
  return s
}

/** 与分销后台分享链接中 shareChannel 一致；拒绝换行等控制字符 */
export function normalizeShareChannel(value: unknown): string | null {
  if (value == null) return null
  let s = String(value).trim()
  if (!s) return null
  if (/[\r\n\0]/.test(s)) return null
  if (s.length > SHARE_CHANNEL_MAX_LEN) s = s.slice(0, SHARE_CHANNEL_MAX_LEN)
  return s
}

/** 从当前路由 query 解析 shareChannel */
export function pickShareChannelFromQuery(query: Record<string, unknown>): string | null {
  const raw = query[DistributionHttpHeaders.SHARE_CHANNEL]
  const first = Array.isArray(raw) ? raw[0] : raw
  return normalizeShareChannel(first)
}

function randomId(): string {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '')
    }
  } catch {
    /* ignore */
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}

/** 匿名访客 ID：Cookie 30 天，与文档 visitor_id 对齐 */
export function getOrCreateVisitorId(): string {
  const cookie = useCookie(JUFAIR_VISITOR_ID_KEY, {
    maxAge: 60 * 60 * 24 * 30,
    path: '/',
    sameSite: 'lax'
  })
  if (cookie.value && String(cookie.value).length > 8) {
    return String(cookie.value)
  }
  const v = randomId()
  cookie.value = v
  return v
}
